<breadcrumbs [path]="breadcrumbs"></breadcrumbs>
<h2 class="mb-3 mt-0">{{localize(langSection.NotificationSettings, langText.NotificationSettings)}}</h2>
<div class="delivery-type">
    <h4 class="mb-0">
        {{localize(langSection.NotificationSettings, langText.DeliveryType)}}
    </h4>
</div>
<div class="delivery-settings-grid">
    <div class="delivery-setting">
        <div>
            <label class="me-1">{{localize(langSection.Term, langText.Email)}}:</label>
            @if (emails) {
<span>{{emails}}</span>
}
            @if(deliveryTypeSettings?.emails?.length === 0 || (deliveryTypeSettings?.emails?.length === 1 && !deliveryTypeSettings?.emails[0])){
            <a href="#" (click)="$event.preventDefault(); openDeliveryTypeModal()">{{localize(langSection.NotificationSettings,
                langText.AddEmailAddress)}}</a>
            }
            @else{
            @if (!dataOutOfDate) {
<a href="#" class="edit-email-link" (click)="$event.preventDefault(); openDeliveryTypeModal()">{{localize(langSection.Term,
                langText.Edit)}}</a>
}
            }
        </div>
        <div class="label-toggle-pair" [class.error]="emailNotificationError">
            <label>{{localize(langSection.NotificationSettings, langText.EmailNotifications)}}:</label>
            <on-off-toggle [active]="deliveryTypeSettings?.emails && deliveryTypeSettings?.emails.length > 0 && validEmail && !dataOutOfDate"
                [boolValue]="deliveryTypeSettings?.emailNotification" (onChange)="saveDeliveryType('emailNotification', $event)"></on-off-toggle>
        </div>
    </div>
</div>
@if (showSettingsGrid) {
<div class="sort-locations-grid">
    <div class="d-flex">

        <h4 class="mb-0" style="padding-top:20px;">
            {{localize(langSection.NotificationSettings, langText.NotificationsToReceive)}}
        </h4>
    </div>
    <div class="d-flex">
        <div class="location-sort">
            <label class="me-1">{{localize(langSection.LocationUserPage, langText.SortLocationsBy)}}</label>
            <div class="sort-controls">
                <ups-select (change)="updateLocationSort($event.target.value)" id="sortBy" [list]="sortOptions" [value]="sortInitVal"></ups-select>
                <button aria-label="Ascending or Descending" class="up-and-down-sort btn" type="button" (click)="toggleAscending()"></button>
            </div>
        </div>
    </div>
    <div class="sort-instructions" style="width:300px;">
        {{localize(langSection.NotificationSettings, langText.SortInstructions)}}
    </div>
</div>
}
@if (showSettingsGrid) {
<location-settings-grid [locations]="locations | filterLocationsList: locationSearchTerm"
    [totalLocationCount]="locations?.length"></location-settings-grid>
}